export enum Wegtyp {
  SCHULWEG = "SCHULWEG",
  PRAKTIKUMSWEG = "PRAKTIKUMSWEG",
  BEIDES = "BEIDES"
}
